import axios from 'axios';

const API_BASE_URL = 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;

// ================= AUTH API =================
export const authAPI = {
  googleLogin: (token) =>
    api.post('/auth/google-login', { token }),

  verifyOTP: (userId, otp) =>
    api.post('/auth/verify-otp', { userId, otp }),
};

// ================= Candidates API =================
export const candidatesAPI = {
  getAll: () => api.get('/candidates'),
  getById: (id) => api.get(`/candidates/${id}`),
  create: (data) => api.post('/candidates', data),
  update: (id, data) => api.put(`/candidates/${id}`, data),
  delete: (id) => api.delete(`/candidates/${id}`),
};

// ================= Interviews API =================
export const interviewsAPI = {
  getAll: () => api.get('/interviews'),
  getByCandidate: (candidateId) =>
    api.get(`/interviews/candidate/${candidateId}`),
  create: (data) => api.post('/interviews', data),
  update: (id, data) => api.put(`/interviews/${id}`, data),

   // ✅ NEW
  updateStatus: (id, data) =>
    api.put(`/interviews/${id}/status`, data),
  
};

// ================= Offers API =================
export const offersAPI = {
  getByCandidate: (candidateId) =>
    api.get(`/offers/candidate/${candidateId}`),
  create: (data) => api.post('/offers', data),
};


// Emails API
export const emailsAPI = {
  sendInterview: (data) => axios.post(`${API_BASE_URL}/emails/interview`, data),
  sendOffer: (data) => axios.post(`${API_BASE_URL}/emails/offer`, data),
  getLogs: () => axios.get(`${API_BASE_URL}/emails/logs`)
};  

// AI API
export const aiAPI = {
  parseResume: (data) => axios.post(`${API_BASE_URL}/ai/parse-resume`, data),
  analyzeResume: (data) => axios.post(`${API_BASE_URL}/ai/analyze-resume`, data),
  getJDSuggestions: (data) => axios.post(`${API_BASE_URL}/ai/jd-suggestions`, data),
  getInterviewTips: (data) => axios.post(`${API_BASE_URL}/ai/interview-tips`, data)
};

//interviewrs api 
export const interviewersAPI = {
  getAll: () => api.get('/interviewers'),
  create: (data) => api.post('/interviewers', data),
  delete: (id) => api.delete(`/interviewers/${id}`)
};

// import axios from 'axios';

// const API_BASE_URL = 'http://localhost:5000/api';

// const api = axios.create({
//   baseURL: API_BASE_URL,
// });

// // ================= Candidates API =================
// export const candidatesAPI = {
//   getAll: () => api.get('/candidates'),
//   getById: (id) => api.get(`/candidates/${id}`),
//   create: (data) => api.post('/candidates', data),
//   update: (id, data) => api.put(`/candidates/${id}`, data),
//   delete: (id) => api.delete(`/candidates/${id}`),
// };

// // ================= Resumes API =================
// export const resumesAPI = {
//   upload: (formData) =>
//     api.post('/resumes/upload', formData, {
//       headers: { 'Content-Type': 'multipart/form-data' },
//     }),
//   getByCandidate: (candidateId) =>
//     api.get(`/resumes/candidate/${candidateId}`),
// };

// // ================= Interviews API =================
// export const interviewsAPI = {
//   getAll: () => api.get('/interviews'),
//   getByCandidate: (candidateId) =>
//     api.get(`/interviews/candidate/${candidateId}`),
//   create: (data) => api.post('/interviews', data),
//   update: (id, data) => api.put(`/interviews/${id}`, data),
// };

// // ================= Offers API =================
// export const offersAPI = {
//   getByCandidate: (candidateId) =>
//     api.get(`/offers/candidate/${candidateId}`),
//   create: (data) => api.post('/offers', data),
// };

// // ================= Emails API =================
// export const emailsAPI = {
//   sendInterview: (data) => api.post('/emails/interview', data),
//   sendOffer: (data) => api.post('/emails/offer', data),
// };

// // ================= AI API =================
// // // AI API
// export const aiAPI = {
//   analyzeResume: (data) => axios.post(`${API_BASE_URL}/ai/analyze-resume`, data),
//   getJDSuggestions: (data) => axios.post(`${API_BASE_URL}/ai/jd-suggestions`, data),
//   getInterviewTips: (data) => axios.post(`${API_BASE_URL}/ai/interview-tips`, data)
// };


// // import axios from 'axios';

// // const API_BASE_URL = 'http://localhost:5000/api';

// // // Candidates API
// // export const candidatesAPI = {
// //   getAll: () => axios.get(`${API_BASE_URL}/candidates`),
// //   getById: (id) => axios.get(`${API_BASE_URL}/candidates/${id}`),
// //   create: (data) => axios.post(`${API_BASE_URL}/candidates`, data),
// //   update: (id, data) => axios.put(`${API_BASE_URL}/candidates/${id}`, data),
// //   delete: (id) => axios.delete(`${API_BASE_URL}/candidates/${id}`)
// // };

// // // Resumes API
// // export const resumesAPI = {
// //   upload: (formData) => axios.post(`${API_BASE_URL}/resumes/upload`, formData, {
// //     headers: { 'Content-Type': 'multipart/form-data' }
// //   }),
// //   getByCandidate: (candidateId) => axios.get(`${API_BASE_URL}/resumes/candidate/${candidateId}`),
// //   getById: (id) => axios.get(`${API_BASE_URL}/resumes/${id}`)
// // };

// // // Interviews API
// // export const interviewsAPI = {
// //   getAll: () => axios.get(`${API_BASE_URL}/interviews`),
// //   getByCandidate: (candidateId) => axios.get(`${API_BASE_URL}/interviews/candidate/${candidateId}`),
// //   create: (data) => axios.post(`${API_BASE_URL}/interviews`, data),
// //   update: (id, data) => axios.put(`${API_BASE_URL}/interviews/${id}`, data)
// // };

// // // Offers API
// // export const offersAPI = {
// //   getById: (id) => axios.get(`${API_BASE_URL}/offers/${id}`),
// //   getByCandidate: (candidateId) => axios.get(`${API_BASE_URL}/offers/candidate/${candidateId}`),
// //   create: (data) => axios.post(`${API_BASE_URL}/offers`, data),
// //   update: (id, data) => axios.put(`${API_BASE_URL}/offers/${id}`, data),
// //   respond: (id, response) => axios.post(`${API_BASE_URL}/offers/${id}/respond`, { response })
// // };

// // // Emails API
// // export const emailsAPI = {
// //   sendInterview: (data) => axios.post(`${API_BASE_URL}/emails/interview`, data),
// //   sendOffer: (data) => axios.post(`${API_BASE_URL}/emails/offer`, data),
// //   getLogs: () => axios.get(`${API_BASE_URL}/emails/logs`)
// // };

// // // AI API
// // export const aiAPI = {
// //   analyzeResume: (data) => axios.post(`${API_BASE_URL}/ai/analyze-resume`, data),
// //   getJDSuggestions: (data) => axios.post(`${API_BASE_URL}/ai/jd-suggestions`, data),
// //   getInterviewTips: (data) => axios.post(`${API_BASE_URL}/ai/interview-tips`, data)
// // };
